import { render, staticRenderFns } from "./classUpdate.vue?vue&type=template&id=774e852b&"
import script from "./classUpdate.vue?vue&type=script&lang=js&"
export * from "./classUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports